const nameScore = (score) => {
  switch (score) {
    case 0:
    case 1:
      return "risky";
    case 2:
      return "weak";
    case 3:
      return "safe";
    case 4:
      return "secure";
    default:
      return "risky";
  }
};

export default nameScore;
